import { switchDevice } from 'src/utils/switchDevice'
import { buildDeviceUserPayload } from 'src/utils/subscriptionExpire'
import {
  isSelectableDevice,
  pickPreferredSelectableDevice
} from 'src/utils/subscriptionStatus'

/**
 * 登录/首页选默认设备，与侧栏 switchDevice 走同一套流程。
 * 永不选中超 30 天失效设备；若传入 lapsed 会自动回退到可选设备或清空选中。
 * @param {Object} params
 * @param {import('redux').Dispatch} params.dispatch
 * @param {Object} [params.device] - 选中的设备记录
 * @param {string} [params.platformType] - 平台类型
 * @param {Array} [params.allDevices] - 全部设备列表，写入 allDeviceUser
 * @param {Object} [params.currentDevice] - 当前物理设备；刷新恢复会话时保留
 * @returns {ReturnType<import('src/utils/deviceContext').buildDeviceContext}|null}
 */
export const bootstrapDeviceSelection = ({ dispatch, device, platformType, allDevices, currentDevice }) => {
  if (allDevices !== undefined) {
    localStorage.setItem('allDeviceUser', JSON.stringify(allDevices))
  }

  const mode = platformType || device?.platform_type || localStorage.getItem('currentMode') || ''
  const deviceList = Array.isArray(allDevices) ? allDevices : []

  let nextDevice = device || null
  if (nextDevice && !isSelectableDevice(nextDevice)) {
    nextDevice =
      pickPreferredSelectableDevice(deviceList, mode) ||
      pickPreferredSelectableDevice(deviceList) ||
      null
  }

  localStorage.setItem('Basic', nextDevice?.iCloud_username ? 1 : 0)

  return switchDevice({
    dispatch,
    deviceUser: nextDevice ? buildDeviceUserPayload(nextDevice) : {},
    // 登录后的页面刷新必须保留当前物理设备，避免先以空设备状态渲染绑定流程。
    currentDevice: nextDevice && currentDevice !== undefined ? currentDevice : {},
    currentMode: mode,
    skipSelectionGuard: !nextDevice
  })
}
